export type SalePaymentStatus = 'pending' | 'scheduling' | 'scheduled' | 'paid';
export type PayoutChannel = 'cash' | 'store_credit' | 'transfer';

export const PAYOUT_CHANNEL_LABELS: Record<PayoutChannel, string> = {
  cash: 'Efectivo',
  store_credit: 'Crédito en tienda',
  transfer: 'Transferencia bancaria',
};

export interface ConsignorSaleItem {
  id: number;
  artId: string | null;
  productName: string;
  variantName: string;
  imageUrl: string | null;
  soldAt: string;
  /** Net payout the consignor receives after Urban Utility commission */
  payoutAmount: number;
  paymentStatus: SalePaymentStatus;
  paymentScheduledDate: string | null;
}

export interface PendingPaymentInfo {
  id: number;
  amount: number;
  channel: PayoutChannel;
  /** ISO date, null if the admin hasn't set a date yet */
  scheduledDate: string | null;
}

export interface ConsignorSalesSummary {
  /** Total payout amount for completed sales with no payment batch yet (status: pending) */
  pendingAmount: number;
  /** True if the consignor already has an open (unpaid) payment batch */
  hasPendingPayment: boolean;
  pendingPayment: PendingPaymentInfo | null;
}

export interface ConsignorSalesPayload {
  items: ConsignorSaleItem[];
  total: number;
  summary: ConsignorSalesSummary;
}
